module.exports = __webpack_public_path__ + "static/1seater_4k-931dbcd9f13d0694a9052e8432ec4d71.jpg";